import { useEffect, useState } from "react";
import api from "../services/api";
// import Banner from "../components/Banner";
import NewsCards from "../components/NewsCards";
import homeBackground from "../assets/img/fondo-home.png";
import "../styles/home.css";
import HeroSection from "../components/HeroSection";
import NewsTicker from "../components/NewsTicker";
import SponsorCarousel from "../components/SponsorCarousel";

const Home = () => {
  const [noticias, setNoticias] = useState([]);
  const [cursos, setCursos] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const noticiasRes = await api.get("/noticias/");
        const cursosRes = await api.get("/cursos/");

        setNoticias(
          noticiasRes.data
          .slice(0, 8)
          .map((n) => ({
            id: n.id,
            titulo: n.titulo,
            descripcion: n.noticia,
            imagen: n.imagen, // URL Cloudinary
          }))
        );

        setCursos(
          cursosRes.data
          .slice(0, 8)
          .map((c) => ({
            id: c.id,
            titulo: c.titulo,
            descripcion: c.descripcion,
            imagen: c.portada, // URL Cloudinary
          }))
        );
      } catch (error) {
        console.error("Error cargando landing:", error);
      }
    };

    fetchData();
  }, []);

  const auspiciadores = [
    {
      titulo:
        "💙 Gracias a HELVETAS por sumarse al Encuentro de Mujeres en el Saneamiento y Agua – Bolivia 2025.",
      descripcion:
        "Su trabajo por la gestión integral del agua, la equidad de género y la resiliencia climática inspira nuestro compromiso con un futuro más justo y sostenible. Juntos seguimos fortaleciendo el liderazgo técnico y social de las mujeres en el sector saneamiento.",
      imagen: "/media/sponsors/sponsor01.gif",
    },
    {
      titulo:
        "💙 Agradecemos a Aguatuya por su valioso apoyo al Encuentro de Mujeres en el Saneamiento y Agua – Bolivia 2025.",
      descripcion:
        "Su compromiso construyendo soluciones participativas e innovadoras que contribuyen a la gestión sostenible del ciclo urbano del agua, mejoran la calidad de vida de las personas y protegen el medio ambiente fortalece la transformación del sector en Bolivia. Gracias por impulsar iniciativas que promueven la equidad, la sostenibilidad y el liderazgo femenino en agua y saneamiento.",
      imagen: "/media/sponsors/sponsor02.jpg",
    },
    {
      titulo:
        "🐅Agradecemos a Tigre por su auspicio y compromiso con el Encuentro de Mujeres en el Saneamiento y Agua – Bolivia 2025.",
      descripcion:
        "Su liderazgo regional en soluciones hidráulicas y su apuesta por la innovación contribuyen a mejorar la calidad y eficiencia de los servicios de agua y saneamiento en Bolivia. Gracias por apoyar la equidad y la sostenibilidad desde la ingeniería.",
      imagen: "/media/sponsors/sponsor03.jpg",
    },
    {
      titulo:
        "👏 Agradecemos a PLASTIFORTE por ser parte del Encuentro de Mujeres en el Saneamiento y Agua – Bolivia 2025.",
      descripcion:
        "Como empresa boliviana líder en soluciones en PEAD, su apuesta por la innovación, la calidad y la sostenibilidad fortalece la infraestructura del país y apoya los Objetivos de Desarrollo Sostenible. Gracias por impulsar junto a nosotros un sector más equitativo, moderno y sostenible.",
      imagen: "/media/sponsors/sponsor04.jpg",
    },
    {
      titulo:
        "💧 Agradecemos profundamente a la Fundación Ingenieros en Acción (FIEA) por su apoyo al Encuentro de Mujeres en el Saneamiento y Agua – Bolivia 2025.",
      descripcion:
        "Su labor en el fortalecimiento de proyectos de agua y saneamiento en comunidades rurales, basada en la colaboración técnica, la equidad y la sostenibilidad, refleja el espíritu del evento: unir conocimiento, innovación y compromiso social para transformar vidas. Gracias por ser parte de esta iniciativa que impulsa el liderazgo femenino y la gestión inclusiva del agua en Bolivia y la región.",
      imagen: "/media/sponsors/sponsor05.jpg",
    },
    {
      titulo:
        "💙 Agradecemos a la Sociedad de Ingenieros de Bolivia – Departamental Santa Cruz (SIB-SCZ) por su valioso apoyo al Encuentro de Mujeres en el Saneamiento y Agua – Bolivia 2025.",
      descripcion:
        "Su compromiso con la excelencia profesional, la formación técnica y el desarrollo sostenible fortalece el liderazgo femenino y la innovación en el sector. Gracias por impulsar espacios que promueven una ingeniería más inclusiva y resiliente.",
      imagen: "/media/sponsors/sponsor06.jpg",
    },
    {
      titulo:
        "💙 Agradecemos al Banco Interamericano de Desarrollo (BID) por su invaluable apoyo al Encuentro de Mujeres en el Saneamiento y Agua – Bolivia 2025.",
      descripcion:
        "Su compromiso con la equidad, la sostenibilidad y el fortalecimiento de los servicios de agua y saneamiento impulsa el desarrollo del sector y promueve el liderazgo femenino en la gestión hídrica. Gracias por ser parte de esta iniciativa que busca construir un futuro más justo, resiliente e inclusivo para todas y todos.",
      imagen: "/media/sponsors/sponsor07.jpg",
    },
    {
      titulo:
        "💧 Agradecemos a GITEC por su valioso apoyo al Encuentro de Mujeres en el Saneamiento y Agua – Bolivia 2025.",
      descripcion:
        "Su compromiso con el desarrollo sostenible y la gestión eficiente del agua refleja la visión que compartimos: construir soluciones técnicas con enfoque humano, equitativo y resiliente. Gracias por acompañarnos en la promoción del liderazgo femenino y la cooperación internacional para un futuro hídrico más sostenible.",
      imagen: "/media/sponsors/sponsor08.jpg",
    },
  ];

  return (
    <>
      <HeroSection />
      <NewsTicker noticias={noticias} />
      {/* <Banner /> */}
      <section
        className="home-container"
        style={{ backgroundImage: `url(${homeBackground})` }}
      >
        <h2>Últimas Noticias</h2>
        <NewsCards noticias={noticias} />
        <div className="home-container-cards">
          <h2>Cursos</h2>
          <NewsCards noticias={cursos} basePath="cursos" />
        </div><div className="home-container-cards">
          <h2>Nuestros Auspiciadores</h2>
          <SponsorCarousel sponsors={auspiciadores} />
        </div>
      </section>
    </>
  );
};

export default Home;
